import { Component, OnInit, Input } from '@angular/core';
import { NG_VALUE_ACCESSOR, ControlValueAccessor } from '@angular/forms';
import { ComparableStatus } from 'src/app/mystudies/_study_constants';

@Component({
  selector: 'app-accept-reject-selection',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: AcceptRejectSelectionComponent,
      multi: true,
    },
  ],
  templateUrl: './accept-reject-selection.component.html',
  styleUrls: ['./accept-reject-selection.component.css'],
})
export class AcceptRejectSelectionComponent implements OnInit, ControlValueAccessor {
  @Input() readOnly: boolean;
  @Input() includeNeutral: boolean;

  /* if there is no element to bind pass "null"( [appendTo]="null" )
   * by default "body" is used as this dropdown is used in grid in most places.
   *Target element to attach the overlay, valid values are "body" or a local ng-template variable of another element.
   * **/
  @Input() appendTo = 'body';

  comparableStatus: typeof ComparableStatus = ComparableStatus;
  value: number;
  options: any[];

  onChange: (value: number) => void;
  onTouched: (value: number) => void;

  ngOnInit() {
    this.options = [
      {
        label: 'Accepted',
        value: ComparableStatus.Accepted,
        class: 'accept',
        icon: 'check_circle',
      },
      {
        label: 'Rejected',
        value: ComparableStatus.Rejected,
        class: 'reject',
        icon: 'cancel',
      },
    ];

    if (this.includeNeutral) {
      this.options.push({
        label: 'Neutral',
        value: ComparableStatus.Neutral,
        class: 'neutral',
        icon: 'remove_circle',
      });
    }
  }

  writeValue(value: number): void {
    this.value = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    // Nothing to declare on touch
    this.onTouched = fn;
  }

  onModelChange(): void {
    this.onChange(this.value);
  }
}
